import { HttpErrorResponse } from '@angular/common/http';

// assign an action based on the statuscode of the error and throw to mobile
export class MobileErrorHandler {
  static throwToMobile(error: HttpErrorResponse): void {
    window?.ReactNativeWebView?.postMessage(JSON.stringify({ enrichedError: error, type: 'error' }));
  }
}
